<template>
    <section>
        <b-row class="grid-header">
            <b-col cols="12">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <div class="d-flex align-items-center">
                        <b-form-checkbox v-model="isIncludeQuarantine" v-if="itemData.filter(x => x.isQuarantined).length > 0" class="mr-2">
                            <h6>Include Quarantined Inventories</h6>
                        </b-form-checkbox>
                        <b-form-checkbox v-model="isOnlyAvailable" @change="checkedRowItemIds = []">
                            <h6>Show available inventories only</h6>
                        </b-form-checkbox>    
                    </div>                
                    <div class="d-flex align-items-center">
                        <b-button
                            v-if="checkClaim(CAN_EDIT_REQUIREMENTS)"
                            size="sm"
                            variant="primary"
                            :disabled="checkedRowItemIds.length == 0"
                            @click="onAddToSources()"
                            class="mr-1">
                            Post to Source
                            </b-button>
                        <b-button size="sm" :variant="isQuarantinedInventorySelected ? 'warning' : 'primary'"
                        :disabled="checkedRowItemIds.length == 0"
                        @click="onAllocate()">
                            Allocate
                        </b-button>
                    </div>
                </div>            
            </b-col>
        </b-row>
        <grid-component
            isResizable
            :gridId="inventoryOnHandGridId"
            :itemData="itemData"
            :navigationField="'partNumber'"
            :dynamicValToLink="'-split-'"
            :onDynamicNav="showDetail"
            :fields="fields"
            @checkedItem="checkedRowItemIds=$event"
        />

        <b-modal id="split-details-modal-on-hand" size="lg" ref="split-details-modal-on-hand" ok-only>
            <template slot="modal-header">
                <h5 class="modal-title">
                    {{ 'Inventory Split Details for Part ' + inventoryOnSplit.partNumber }}
                    <i v-show="isLoadingSplit" class="fa fa-spinner fa-pulse fa-fw"></i>
                </h5>
            </template>
            <inventory-split-component />
        </b-modal>
    </section>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import GridComponent from '@/shared/components/GridComponent';
import fields from '@/pages/Inventory/fields';
import { GRID_ID } from '@/shared/constants';
import InventorySplitComponent from '@/shared/components/InventorySplits';

export default {
    components: {
        GridComponent,
        InventorySplitComponent
    },
    props: {
        reqLineId: {
            type: [Number, String],
            default: 0
        },
        partId: {
            type: [Number, String],
            default: 0,
        },
        salesOrderLineId: {
            type: [Number, String],
            default: 0
        }
    },
    data() {
        return {
            fields,
            checkedRowItemIds: [],
            inventoryOnHandGridId: GRID_ID.INVENTORY_SALES_ORDERS_ON_HAND_GRID,
            inventoryOnSplit: {},
            isLoadingSplit: false,
            isIncludeQuarantine: false,
            showSources: [1, 4],
            isOnlyAvailable: true,
            isIncludeOnHold: false
        }
    },
    computed: {
        ...mapGetters('inventory', ['inventoryListForPartById']),
        itemData() {
            let onHands = this.inventoryListForPartById(this.partId).filter(x => this.showSources.includes(x.sourceId) 
                && (x.isQuarantined == false || x.isQuarantined == this.isIncludeQuarantine)
                && x.onHand > 0);

            let result = (this.isOnlyAvailable) ? onHands.filter(x => x.available > 0) : onHands;
            
            return result;
        },
        selectedInventory() {
            return this.itemData.filter(x => this.checkedRowItemIds.includes(x.id));
        },
        isQuarantinedInventorySelected() {
            return this.selectedInventory.filter(x => x.isQuarantined == true).length > 0;
        },
        isUnavailableInventorySelected() {
            return this.selectedInventory.filter(x => x.available <= 0).length > 0;
        }
    },
    methods: {
        ...mapActions('inventory', ['allocateInventory', 'getInventorySplits', 'getInventoryAvailableParts']),
        ...mapActions('salesOrderLineSources', ['addSources']),
        // ...mapMutations('inventory', ['setInventorySplitList'])
        ...mapMutations('inventory', [ 'setInventoryListForPart']),
        ...mapMutations('inventory', {inventorySetItem: 'setItem'}),
        async onAllocate() {
            let toAllocate = true;
            if (this.isQuarantinedInventorySelected) {
                toAllocate = await this.openConfirmBox({
                    message: 'You have selected an inventory with a QUARANTINED state. Are you sure you want to allocate? Note: Quarantine inventories will be made active if allocated. '
                })
            }
            if (this.isUnavailableInventorySelected) {
                toAllocate = await this.openConfirmBox({
                    message: 'You have selected an inventory with UNAVAILABLE QUANTITY. Note: these unavailable inventories will not be allocated to this sales order item. '
                })
            }

            if (toAllocate) {
                await this.allocateInventory({
                    salesOrderLineId: this.salesOrderLineId,
                    inventory: this.selectedInventory
                }).then((res) => {
                    if (res.length > 0) {
                        this.$snotify.success('Successfully allocated selected inventory')
                    } else {
                        this.$snotify.info('Check availability of the inventory selected')
                    }
                });
                
                this.$emit('refreshAvailableParts');
                this.checkedRowItemIds = [];
            }
            
        },
        async showDetail(row) {
          try {
            this.isLoadingSplit = true;
            // this.setInventorySplitList([]);
            this.inventorySetItem({ resource:'inventorySplitList', payload: [] });
            this.inventoryOnSplit = row;
            this.$bvModal.show('split-details-modal-on-hand');
            await this.getInventorySplits(row.id);
            this.isLoadingSplit = false;
          }catch (e) {
            this.isLoadingSplit = false;
          }
        },
        async onAddToSources() {
            let obj = this.selectedInventory.map(inv => {
                return {
                    id: 0,
                    salesOrderLineId: this.salesOrderLineId,
                    inventoryId: inv.id,
                    quantity: inv.onHand || 0,
                    partId: inv.partId,
                    cost: inv.cost || 0,
                    active: inv.active,
                };
            });

            this.$snotify.info('Posting Inventory to Source', 'Sources');
            await this.addSources(obj).then(() => {
                this.checkedRowItemIdsArr = [];
                this.$snotify.success('Posted Inventory to Source', 'Sources');
            });
        },
        async getData() {
            if(!this.partId) { this.setInventoryListForPart({partId:this.partId,data:[]})}
            if(this.partId) { this.getInventoryAvailableParts(this.partId); }
        },
    },
    watch: {
        partId() { this.getData() }
    }
}
</script>

<style>

</style>